export default {
  admin: () => import("/home/deploy/webhook-lisenter/tduck-cms/layouts/admin.vue").then(m => m.default || m),
  default: () => import("/home/deploy/webhook-lisenter/tduck-cms/layouts/default.vue").then(m => m.default || m),
  home: () => import("/home/deploy/webhook-lisenter/tduck-cms/layouts/home.vue").then(m => m.default || m)
}